import { Banner } from '@shopify/polaris';
import React  from 'react';

const UploadLimitBanner = ({handleOff})=> {
  
    return (
        <div>
            <Banner
            title="Variant Limit Reached"
            tone="warning"
            action={{content: 'View Details', url: 'https://help.shopify.com/en/manual/products/import-export/common-import-issues?utm_source=sidekick',target: '_blank'}}
            onDismiss={() => {handleOff()}}
            >
            <p>
            According to Shopify's policy, your store has exceeded a total of 50,000 variants. As a result, you can add no more than 1,000 new variants per day. You have reached today's limit of 1,000 variants. Please try again tomorrow or consider upgrading to Shopify Plus.
            </p>
            </Banner>
        </div>
    );
}

export default UploadLimitBanner;
